import { render, staticRenderFns } from "./final.vue?vue&type=template&id=af4739c6&scoped=true&"
import script from "./final.vue?vue&type=script&lang=js&"
export * from "./final.vue?vue&type=script&lang=js&"
import style0 from "./final.vue?vue&type=style&index=0&id=af4739c6&prod&scoped=true&lang=css&"
import style1 from "./final.vue?vue&type=style&index=1&id=af4739c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4739c6",
  null
  
)

export default component.exports